import React from "react";
import beerIcon from "../assets/page_logo.png"; // ✅ Ensure this path is correct

/**
 * `onMenuClick` is optional on purpose: the bar is rendered on its own elsewhere, and passing
 * nothing keeps it exactly as it was. The shell only passes a handler below the drawer
 * breakpoint, so no hamburger exists on desktop. AC-MOBILE-F3.
 */
const AdminAppBar = ({ onMenuClick, isMenuOpen = false }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "60px",
        backgroundColor: "#F9F4EA",
        display: "flex",
        alignItems: "center",
        padding: "0 20px",
        boxSizing: "border-box",
        borderRadius: "16px", // rounded corners
        boxShadow: "0 6px 20px rgba(0,0,0,0.25)", // stronger shadow for visibility
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <img
          src={beerIcon}
          alt="Beer Icon"
          style={{
            width: "58px",
            height: "58px",
          }}
        />
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "bold",
            fontSize: "24px",
            color: "#DE810E", // MyHoom text color
          }}
        >
          my HOOM
        </span>
      </div>

      {onMenuClick && (
        <button
          type="button"
          onClick={onMenuClick}
          aria-label={isMenuOpen ? "Close navigation" : "Open navigation"}
          aria-expanded={isMenuOpen}
          aria-controls="admin-nav-drawer"
          style={{
            marginLeft: "auto",
            width: "44px",
            height: "44px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
            border: "none",
            borderRadius: "8px",
            background: "transparent",
            cursor: "pointer",
            padding: 0,
          }}
        >
          {/* Three bars, drawn rather than shipped as an icon — every other glyph in this
              app is a PNG import and this one is two rules of CSS. */}
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              style={{
                display: "block",
                width: "22px",
                height: "2px",
                borderRadius: "2px",
                backgroundColor: "#303030",
              }}
            />
          ))}
        </button>
      )}
    </div>
  );
};

export default AdminAppBar;
